import React from 'react';
import MuiAlert from '@mui/material/Alert';

import './WarningNotice.scss';

/**
 * A page-level warning: something about the state of the page the reader should know before
 * acting, as opposed to the result of an action, which is a snackbar.
 *
 * <p>One component and one look, so that a warning reads the same wherever it appears and the
 * style is changed in one place. They were three different things before this — a full-width amber
 * bar, an outlined alert, and red text at 2.9em on a page students can see.
 *
 * @param className placement only — margins and where it sits. Not its appearance.
 */
const WarningNotice = ({ children, className = '' }) => (
    <MuiAlert severity="warning" className={`warning-notice ${className}`.trim()}>
        {children}
    </MuiAlert>
);

export default WarningNotice;
